import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {GameCenterWidgetConfig} from "./game-center-widget.config";
import {GameCenterWidgetState} from "./models/game-center-widget.state";

export class GameCenterWidgetStore extends BaseMobxStore {
  static injectables = [GameCenterWidgetConfig, GameCenterWidgetState];

}
